<template>
  <v-container v-resize="onResize" style="padding: 0px; max-width: 100%">
    <DashboardComponent
      mod="cul"
      :grid.sync="layout"
      :updated.sync="layoutUpdate"
      :comps="comps"
      :size="size"
      :height="height"
    />
  </v-container>
</template>
<script>
import ApexColumn from "@/../../coreui/library/ApexColumn";
import ApexGeneric from "@/../../coreui/library/ApexGeneric";
import ApexStacked from "@/../../coreui/library/ApexStacked";
import TimelineChart from "@/../../coreui/library/TimelineChart";
import DashboardComponent from "@/../../coreui/library/DashboardComponent";
import axiosInstances from "@/../../coreui/server/axiosInstances";
import TextItem from "@/../../coreui/library/TextGridItem";
import helper from "./helper";
import ui from "@/../../coreui/helpers/ui";
import utils from "@/../../coreui/helpers/utils";
import { sync } from "vuex-pathify";

export default {
  components: {
    DashboardComponent,
    // Gauge,
    // ApexTest,
    // ApexPie
  },
  data: () => ({
    totalRecords: 0,
    lastheight: 40,
    col1start: 1,
    height: 40,
    windowSize: {
      x: 0,
      y: 0,
    },
    harvests: { labels: [], values: [] },
    strains: { labels: [], values: [] },
    trims: { labels: [], values: [] },
    plantings: { labels: [], values: [] },

    stateValues: {},
    plantedDates: [],
    growPhase: [],
    strainCount: [],
    labels: [],
    values: [],
    debouncer: true,
    layoutUpdate: false,
    layout: [
      {
        x: 0,
        y: 0,
        w: 5,
        h: 1,
        i: 0,
        static: true,
        isDraggable: false,
        isResizable: false,
      },
      {
        x: 0,
        y: 1,
        w: 2,
        h: 1,
        i: 1,
        static: true,
        isDraggable: false,
        isResizable: false,
      },
      {
        x: 0,
        y: 2,
        w: 2,
        h: 1,
        i: 2,
        static: true,
        isDraggable: false,
        isResizable: false,
      },
      {
        x: 0,
        y: 3,
        w: 2,
        h: 1,
        i: 3,
        static: true,
        isDraggable: false,
        isResizable: false,
      },
      {
        x: 0,
        y: 4,
        w: 2,
        h: 1,
        i: 4,
        static: true,
        isDraggable: false,
        isResizable: false,
      },
      {
        x: 0,
        y: 5,
        w: 2,
        h: 1,
        i: 5,
        static: true,
        isDraggable: false,
        isResizable: false,
      },
      {
        x: 0,
        y: 6,
        w: 2,
        h: 1,
        i: 6,
        static: true,
        isDraggable: false,
        isResizable: false,
      },
      {
        x: 0,
        y: 7,
        w: 2,
        h: 1,
        i: 7,
        static: true,
        isDraggable: false,
        isResizable: false,
      },
      // {
      //   x: 0,
      //   y: 8,
      //   w: 2,
      //   h: 1,
      //   i: 8,
      //   static: true,
      //   isDraggable: false,
      //   isResizable: false,
      // },
      {
        x: 10,
        y: 0,
        w: 2,
        h: 1,
        i: 10,
        static: true,
        isDraggable: false,
        isResizable: false,
      },

      { x: 3, y: 1, w: 6, h: 4, i: 9 , isResizable: false, static: true, isDraggable: false},
      // { x: 4, y: 2, w: 4, h: 6, i: 7 },
      // { x: 8, y: 2, w: 4, h: 6, i: 8 },
      // { x: 0, y: 7, w: 6, h: 6, i: 9 },
      // { x: 6, y: 7, w: 6, h: 6, i: 10 },
    ],
    size: 13,
  }),

  computed: {
    width() {
      this.windowSize.x / 12;
    },
    mqttTableUpdated: sync("mqtt/mqttTableUpdated"),
    loggedinOrg: sync("login/loggedinOrg"), //sync('login/loggedinUser'),
    comps() {
      return [
        {
          args: {
            s: 10,
            flat: true,
            align: 'center',
            value: "Refresh Now",
            // value: this.totalRecords.unsynced + this.totalRecords.waiting == 0 ? 
            //   '(All Records are UpToDate)' :
            //   '(Some Records are yet to be Synced)',
            labelFontSize: '1.3em',
            valueFontSize: '1.0em',
            valueTextColor: this.totalRecords.unsynced + this.totalRecords.waiting == 0 ? 
            'green' : 'green'
          },
          component: TextItem,
        },
        {
          args: {
            s: 0,
            flat: true,
            align: 'center',
            label: "METRC Compliance Dashboard",
            value: this.totalRecords.unsynced + this.totalRecords.waiting == 0 ? 
              '(All Records are UpToDate)' :
              '(Some Records are yet to be Synced)',
            labelFontSize: '1.3em',
            valueFontSize: '1.0em',
            valueTextColor: this.totalRecords.unsynced + this.totalRecords.waiting == 0 ? 
            'green' : 'darkOrange'
          },
          component: TextItem,
        },
        // {
        //   args: {
        //     s: 1,
        //     flat: true,
        //     align: 'right',
        //     label: "",
        //     value: 'METRC Tag Usage',
        //   },
        //   component: TextItem,
        // },
        {
          args: {
            s: this.col1start,
            flat: true,
            align: 'right',
            label: "Current Tags in Use",
            value: (this.totalRecords.count || 0).toLocaleString(),
          },
          component: TextItem,
        },
        {
          args: {
            s: this.col1start + 1,
            flat: true,
            align: 'right',
            label: "Waiting for First Sync",
            value: (this.totalRecords.unsynced || 0).toLocaleString() ,
          },
          component: TextItem,
        },
        {
          args: {
            s: this.col1start + 2,
            flat: true, 
            align: 'right',
            label: "Waiting for Update",
            value: (this.totalRecords.waiting || 0).toLocaleString(),
          },
          component: TextItem,
        },
        {
          args: {
            s: this.col1start + 3,
            flat: true,
            align: 'right',
            label: "Plant Tags",
            value: (this.totalRecords.plants || 0).toLocaleString(),
          },
          component: TextItem,
        },
        {
          args: {
            s: this.col1start + 4,
            flat: true,
            align: 'right',
            label: "Planting Tags",
            value: (this.totalRecords.plantings || 0).toLocaleString(),
          },
          component: TextItem,
        },
        {
          args: {
            s: this.col1start + 5,
            flat: true,
            align: 'right',
            label: "Package Tags",
            value: (this.totalRecords.packages || 0).toLocaleString(),
          },
          component: TextItem,
        },
        {
          args: {
            s: this.col1start + 6,
            flat: true,
            align: 'right',
            label: "Total Tags Processed",
            value: (this.totalRecords.total || 0).toLocaleString(),
          },
          component: TextItem,
        },
        {
          args: {
            type: 'bar',
            name: "widget 2",
            graphTitle: "METRC Sync History",
            stacked: true,
            flat: true,
            values: this.totalRecords.history ? this.totalRecords.history.values : [],
            // unit: "lb",
            xaxis: {
              type: 'datetime',
              categories: this.totalRecords.history ? this.totalRecords.history.dates : [],
            },
            // labels: [
            //   '-5', '-4', '-3', '-2', '-1', '0'
            // ],
            // title: "Harvests",
            subtitle: "Wet Weights",
            graphSub: "Weight in lb",
            fullscreen: true,
            s: 9,
            // height: this.height,
            // width: this.width,
            date: true,
            palette_light: "palette1",
            palette_dark: "palette2",
            // 'colorize': false,
            annotate: false,
            loading: false,
            // 'series': {0: {type: 'line'}}
          },
          component: ApexGeneric //ApexStacked, // ApexPie //ComboChart
        },
        {
          args: {
            name: "widget 1",
            values: [
              {
                name: "Flowering",
                data: this.strains.fvalues ? this.strains.fvalues : [],
              },
              {
                name: "Vegetative",
                data: this.strains.vvalues ? this.strains.vvalues : [],
              },
              {
                name: "Dead",
                data: this.strains.dvalues ? this.strains.dvalues : [],
              },
              {
                name: "Destroyed",
                data: this.strains.xvalues ? this.strains.xvalues : [],
              },
            ],
            stacked: true,
            labels: this.strains.labels,
            title: "Plants by Strain",
            subtitle: "Active Plants",
            fullscreen: true,
            s: 11,
            height: this.height,
            width: this.width,
            loading: false,
            palette_light: "palette5",
            palette_dark: "palette6",
          },
          component: ApexColumn, // ApexPie //PieChart
        },
        {
          args: {
            name: "widget 2",
            values: [
              {
                name: "Plant Count",
                data: this.harvests.counts ? this.harvests.counts : [],
              },
            ],
            labels: this.harvests.countlabels,
            title: "Harvests",
            subtitle: "Plant Count",
            fullscreen: true,
            s: 11,
            height: this.height,
            width: this.width,
            // 'colorize': true,
            annotate: false,
            loading: false,
            palette_light: "palette7",
            palette_dark: "palette8",
          },
          component: ApexColumn,
        },
        {
          args: {
            stacked: true,
            name: "widget 2",
            values: [
              {
                name: "Flower",
                data: this.trims.fvalues ? this.trims.fvalues : [],
              },
              {
                name: "Smalls",
                data: this.trims.svalues ? this.trims.svalues : [],
              },
              {
                name: "Trim",
                data: this.trims.tvalues ? this.trims.tvalues : [],
              },
            ],
            labels: this.trims.labels,
            title: "Processed Harvests",
            subtitle: "Dry Weight",
            fullscreen: true,
            s: 11,
            height: this.height,
            width: this.width,
            // 'colorize': true,
            annotate: false,
            loading: false,
            palette_light: "palette1",
            palette_dark: "palette2",
          },
          component: ApexColumn,
        },
        {
          args: {
            stacked: true,
            name: "widget 2",
            values: [
              {
                name: "Live",
                data: this.plantings.live ? this.plantings.live : [],
              },
              {
                name: "Dead",
                data: this.plantings.dead ? this.plantings.dead : [],
              },
            ],
            labels: this.plantings.labels,
            title: "Plantings",
            subtitle: "Live/Dead Count",
            fullscreen: true,
            s: 12,
            height: this.height,
            width: this.width,
            // 'colorize': true,
            annotate: false,
            loading: false,
            palette_light: "palette1",
            palette_dark: "palette2",
          },
          component: ApexColumn,
        },
      ];
    },
  },
  watch: {
    mqttTableUpdated: {
      async handler(val) {
        this.elog("debug", "mqtt callback for updating table: {}", val)();
        if (
          val == "cul_harvest" ||
          val == "cul_process" ||
          val == "cul_trim" ||
          val == "cul_palntings"
        ) {
          await this.getData();
        }
        this.mqttTableUpdated = "";
      },
    },
    loggedinOrg: {
      deep: true,
      handler () {
        this.getData()
      }
    },
    layout: {
      deep: true,
      handler: function (newVal, oldVal) {
      },
    },
  },
  methods: {
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
      if (this.windowSize.y != this.lastheight) {
        this.height = this.windowSize.y;
        this.lastheight = this.height;
      }
    },
    getCurTime() {
      let d = new Date(Date.now());
      return d;
    },

    async getData() {
      this.harvests = await helper.getHarvests();
      this.strains = await helper.getStrains();
      this.trims = await helper.getTrims();
      this.plantings = await helper.getPlantings();
      this.totalRecords = await helper.getCompliance(this.loggedinOrg.name)
      console.log('totalRecords: ', this.totalRecords)
    },
  },

  async mounted() {
    this.onResize();
    for (let i = 0; i < this.comps.length; i++) {
      this.comps[i].args.loading = true;
    }
    await this.getData();
    for (let i = 6; i < 10; i++) {
      this.comps[i].args.loading = false;
    }
  },

  beforeDestroy() {
  },
};
</script>

